if (document.querySelector(".jdgm-carousel-wrapper")){
    addEventListener('load', () => {
        const reviewCount = document.querySelector(".jdgm-carousel-number-of-reviews").dataset.numberOfReviews;
        const reviewScore = document.querySelector(".jdgm-all-reviews-rating").dataset.score;
        const reviewScoreOneDecimal = (Math.round(reviewScore * 10) / 10).toFixed(1)
        document.querySelector("#review-number").textContent = reviewCount;
        document.querySelector("#rating-value").textContent = reviewScoreOneDecimal;
    })
}


